import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { useProject } from '@/contexts/ProjectContext';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Routes the signed-in user may open on the selected project, straight from
 * the sidebar API (which already applies module activation + membership).
 * `isFullAccess` is true for platform admins and legacy accounts.
 */
export function useAllowedModules() {
  const { projectId } = useProject();
  const { user } = useAuth();
  const [state, setState] = useState({ paths: null, isFullAccess: true, loading: true });

  useEffect(() => {
    let cancelled = false;
    if (!projectId || !user) { setState({ paths: null, isFullAccess: true, loading: false }); return; }
    api.get(`/projects/${projectId}/sidebar`)
      .then(res => {
        if (cancelled) return;
        setState({
          paths: new Set(res.data?.allowedPaths || []),
          isFullAccess: res.data?.isFullAccess !== false,
          loading: false,
        });
      })
      // Fail closed: a transient error must not reveal modules the user may
      // not open. An empty allow-list hides every tile until the call succeeds.
      .catch(() => { if (!cancelled) setState({ paths: new Set(), isFullAccess: false, loading: false }); });
    return () => { cancelled = true; };
  }, [projectId, user]);

  return state;
}
